<template>
  <div class="ele-checklist" @click="detail()">
    <p class="tit-ele-checklist">{{this.item.cust}}</p>
    <div class="info-ele-checklist"><span>提交人:{{this.item.applyName}}</span><span class="color-gray">{{this.item.time}}</span></div>
    <p class="tag-ele-checklist bg-blue" v-if="item.approveType==approveParam.visitReport">访问报告</p>
    <p class="tag-ele-checklist bg-pl" v-if="item.approveType==approveParam.customer">客户</p>
    <p class="tag-ele-checklist bg-red" v-if="item.approveType==approveParam.invalidReport">过期报告</p>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'ApproveItem',
  data() {
    return {
      
    }
  },
  props:['item'],
  methods:{
    detail(){
      if(this.item.approveType==this.approveParam.visitReport||this.item.approveType==this.approveParam.invalidReport){
        this.$router.push('/visitReport/'+this.item.id+'/'+this.item.approveType)
      }else if(this.item.approveType==this.approveParam.customer){
        this.$router.push('/customerApprove/'+this.item.id)
      }
    }
  },
   computed: {
    ...mapState('systemAbout', ['approveParam']),
  },
}
</script>

<style scoped>
</style>